/*jslint node: true, browser: true*/

"use strict";

var $ = require("pli/jquery");
var pli = require("pli/forms");

require("pli/forms-viewmodel");

//---------------------------------------
function DownloadContext(id) {
    this.id = id;
    this.d = new $.Deferred();
}


//---------------------------------------
DownloadContext.prototype.verify = function verifyDownload(response) {
    if (response.isError || !response.result) {
        this.d.reject({ isError: true });
    } else {
        if (typeof pli.dialogClosingMessage === "function") { // temporarily ignore closing message
            this.originalDialogClosingMessage = pli.dialogClosingMessage;
            pli.dialogClosingMessage = this.preventClosingMessage.bind(this);
        }
        window.location = pli.resolveUrl("~/Download/".concat(response.result));
        this.d.resolve({ isError: false });
    }
};


//---------------------------------------
DownloadContext.prototype.preventClosingMessage = function preventDownloadClosingMessage() {
    pli.dialogClosingMessage = this.originalDialogClosingMessage;
    this.originalDialogClosingMessage = null;
    return null;
};


//---------------------------------------
pli.download = pli.download || function downloadFile(id) {
    /// <summary>
    /// Downloads a file from the filestore
    /// using the specified id.
    /// </summary>
    /// <returns>
    /// A jQuery Deferred promise indicating either
    /// success or failure.
    /// </returns>
    if (typeof id !== "string" && id.length === 0) { throw new Error("id must be non-empty string"); }
    var context = new DownloadContext(id);
    pli.call({
        name: "Geo-FileStore-Download",
        data: id
    }).always(context.verify.bind(context));
    return context.d.promise();
};

module.exports = pli.download;


//////////////////
// WEBPACK FOOTER
// ./app/filestore/fileStoreDownload.js
// module id = 482
// module chunks = 49